export default "__VITE_ASSET__DvTbGTQu__"